<template lang="html">
	<div id="app" class="main column no-header">
		<div class="background-login"></div>
		<div class="login active fromsign">
			<img src="~@/common/assets/img/logo-patrim.svg" alt="">
			<div class="status column" v-if="info">
				<div class="label row">
					<img :src="info.img" alt="">
					{{ info.label }}
				</div>
				<div class="description">
					{{ info.text }}
				</div>
			</div>
			<div class="go-to-login row">
				<div @click="goOut" class="btn btn-red">
					Accéder à mon espace client
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Good from '@/common/assets/img/good.svg'
import Clock from '@/common/assets/img/clock.svg'
import Error from '@/common/assets/img/error.svg'
import { mapGetters } from 'vuex'
export default {
	data () {
		return {
			status: null,
			infos: [
				{
					key: 'success',
					img: Good,
					label: 'Signature validée',
					text: 'Votre signature électronique a bien été apposé à votre document. Retrouvez votre document signé dans votre rubrique “Mes documents”.'
				},
				{
					key: 'cancel',
					img: Clock,
					label: 'Signature en cours de validation',
					text: 'Votre signature électronique a bien été prise en compte mais n’a pas encore été validée. Après validation votre document signé sera disponible dans votre rubrique “Mes documents”. Si vous ne parvenez pas à valider votre signature, contactez votre conseiller.'
				},
				{
					key: 'fail',
					img: Error,
					label: 'Signature en erreur',
					text: ' Votre signature électronique a échoué et n’a pas pu être validé. Veuillez soumettre à nouveau la signature électronique via le lien que vous avez reçu. Si le problème persiste, contactez votre conseiller.'
				}
			]
		}
	},
	methods: {
		goOut () {
			if (this.isUser) {
				this.$router.push({ name: 'Main' })
			} else {
				this.$router.push({ name: 'Login' })
			}
		}
	},
	mounted () {
		this.status = this.$route.params.status
	},
	computed: {
		...mapGetters({
			isUser: 'isAuthenticated'
		}),
		info () {
			let result = null
			this.infos.forEach((i) => {
				if (i.key === this.status) {
					result = i
				}
			})

			return result
		}
	}
}
</script>

<style lang="scss" scoped>
.fromsign {
	max-width: 390px;
	width: 100%;
	padding-bottom: 2rem;
	.status {
		padding: 1rem;
		.label {
			font-weight: bold;
			margin-bottom: 1rem;
			img {
				border: none;
				padding: 0;
				width: 1.1rem;
				margin-right: 0.5rem;
			}
		}

		.description {
			text-align: center;
			padding: 0 1rem;
			font-size: 0.8rem;
			font-weight: lighter;
		}

		.go-to-login {
			padding: 2rem;
			margin-bottom: 2rem;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/views/FromSign.vue